import React, { useEffect, useState, useRef } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  fetchData,
  sortItem,
} from "./productSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { showErrorDialog, showSuccessDialog } from "../../utility";
import { Button } from "react-bootstrap";

export const ProductSort = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);

  const [points, setPoints] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchData({ pageNo: 1, pageSize: -1 }));
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (data && data.length > 0) {
      const mapped = data.map((item, index) => ({
        id: item.id,
        no: index + 1,
        product_code: item.product_code,
        product_name: item.product_name,
        product_id: item.product_id,
      }));
      setPoints(mapped);
    }
  }, [data]);

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();

    // Auto-scroll logic
    const container = scrollContainerRef.current;
    if (container) {
      const { top, bottom } = container.getBoundingClientRect();
      const offset = 50; // jarak trigger scroll

      if (e.clientY < top + offset) {
        container.scrollTop -= 20; // scroll ke atas
      } else if (e.clientY > bottom - offset) {
        container.scrollTop += 20; // scroll ke bawah
      }
    }
  };

  const handleDrop = (e, targetIndex) => {
    const sourceIndex = e.dataTransfer.getData("index");
    const newData = [...points];
    const item = newData.splice(sourceIndex, 1)[0];
    newData.splice(targetIndex, 0, item);
    setPoints(newData);
  };

  const handleSave = async () => {
    try {
      const response = await dispatch(sortItem(points));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        await history.goBack();
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Product Sort">
        <CardHeaderToolbar>
          <Button
            className="btn btn-secondary mr-3"
            onClick={() => history.goBack()}
          >
            <i className="fa fa-arrow-left"></i>Back
          </Button>

          <Button
            className="btn btn-danger"
            onClick={handleSave}
          >
            Save
          </Button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <div
          ref={scrollContainerRef}
          style={{
            margin: "20px",
            maxHeight: "600px",
            overflowY: "auto",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              {points.map((item, index) => (
                <tr
                  key={item.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, index)}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, index)}
                  style={{
                    padding: "8px",
                    border: "1px solid #ddd",
                    cursor: "move",
                  }}
                >
                  <td
                    style={{
                      padding: "12px",
                      border: "1px solid #ddd",
                    }}
                  >
                    <span>
                      <b>{item.no}</b>
                    </span>
                  </td>
                  <td
                    style={{
                      padding: "12px",
                      border: "1px solid #ddd",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <span>
                      <b>
                        {item?.product_code} - {item?.product_name}
                      </b>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardBody>
    </Card>
  );
};
